"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Grid_1 = __importDefault(require("@material-ui/core/Grid"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
exports.default = react_1.default.memo(Header);
const useStyles = makeStyles_1.default((theme) => ({
    title: {
        color: theme.colors.header.primaryTextColor,
        marginLeft: 24,
        whiteSpace: "nowrap"
    }
}));
function Header(props) {
    const classes = useStyles();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Grid_1.default, { component: "header", container: true, justifyContent: "space-between", alignItems: "center" },
            react_1.default.createElement(Grid_1.default, { item: true },
                react_1.default.createElement(Grid_1.default, { container: true, alignItems: "center" },
                    react_1.default.createElement(Grid_1.default, { item: true }, props.leftIcon),
                    react_1.default.createElement(Grid_1.default, { item: true, className: classes.title },
                        react_1.default.createElement(Typography_1.default, { variant: "h6" }, props.title)))),
            react_1.default.createElement(Grid_1.default, { item: true }, props.rightIcon))));
}
